<template>
	<div
		class="
			mdc-text-field-helper-line
			mdc-select-helper-line
			mdc-select-helper-text
			mdc-select-helper-text--persistent
			mdc-select-helper-text--validation-msg
			calculator__error
		"
	>
		<div
			:id="`${name}-hint`"
			class="
				mdc-text-field-helper-text
				mdc-text-field-helper-text--persistent
				mdc-text-field-helper-text--validation-msg
			"
		>
			<p :id="`${name}-error`" class="ln-form__error">
				<span v-if="invalidHint" class="calculator__error-hint">{{ invalidHint }}</span>
			</p>
			<p>{{ hint }}</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'InputHint',
	props: {
		name: String,
		hint: String,
		invalidHint: String
	}
};
</script>

<style>
@import url('../assets/css/variables.css');

.calculator__error-hint {
	display: none;
}

.mdc-text-field--invalid ~ .calculator__error .calculator__error-hint {
	display: block;
}

/* Spacing */
.calculator__error .mdc-text-field-helper-text {
	margin-top: 0;
}
.calculator__error p:first-child {
	margin-top: 0.375rem;
	display: block;
}
.calculator__error p:empty {
	display: none;
}
</style>
